module.exports = __webpack_public_path__ + "static/img/table_head_dock.c05921a.jpeg";